var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "handover",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.259,
    height: 74,
    viewBox: "0 0 111.259 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 111.259,
    height: 74,
    rx: 8,
    fill: "#020202",
    opacity: 0.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M43.237,30a1.723,1.723,0,0,1-1.706-1.74A10.343,10.343,0,0,1,51.771,17.813H57.02A10.343,10.343,0,0,1,67.259,28.26,1.723,1.723,0,0,1,65.554,30ZM3.676,30A3.716,3.716,0,0,1,0,26.25V3.75A3.717,3.717,0,0,1,3.676,0h9.188V7.5A1.855,1.855,0,0,0,14.7,9.375h7.351V26.25A3.716,3.716,0,0,1,18.377,30ZM36.438,5.4V1.293l7.385,7.187-7.385,7.205V11.467c-5.132,0-8.51,1.638-11.077,5.239C26.394,11.563,29.256,6.439,36.438,5.4ZM48.03,11.25a7.631,7.631,0,0,1,0-7.5,7.278,7.278,0,0,1,12.732,0,7.631,7.631,0,0,1,0,7.5,7.279,7.279,0,0,1-12.732,0ZM14.7,7.5V0l7.351,7.5Z",
    transform: "translate(22.242 22)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandover);
export default __webpack_public_path__ + "static/media/handover.dabfe0c074923f5937f8bf63d10962ed.svg";
export { ForwardRef as ReactComponent };